import { useClient } from '@based/sdk/react'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { enrich } from '@i18n/localizeHelper'
import { useCallback } from 'react'
import { SearchSuggestion, SuggestionsFetcher } from './SearchField'
import { Icon } from '@app/components/core/icon/Icon'
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons'

export const useLocationSuggestions = (): SuggestionsFetcher => {
  const client = useClient()
  const [language] = useLanguage()
  const translations =
    i18n.languages[language].app.discoveryPage.searchSuggestions

  return useCallback(
    (
      searchTerm: string,
      setSuggestions: (suggestions: SearchSuggestion[]) => void,
    ) => {
      let municipalitySuggestions: SearchSuggestion[] = []
      let regionSuggestions: SearchSuggestion[] = []

      const updateSuggestions = () => {
        setSuggestions([...municipalitySuggestions, ...regionSuggestions])
      }

      const closeP = client
        .query('suggestions-municipality', {
          searchTerm,
          top: 4,
        })
        .subscribe((municipalities) => {
          municipalitySuggestions = municipalities.map(
            (m: { name: string; region: { name: string } }) => ({
              key: `municipality-${m.name}`,
              label: m.name,
              sublabel: enrich(translations.municipality, m.region.name),
              icon: <Icon variant="gray" icon={faLocationDot} />,
            }),
          )
          updateSuggestions()
        })

      const closeR = client
        .query('suggestions-region', {
          searchTerm,
          top: 4,
        })
        .subscribe((regions) => {
          regionSuggestions = regions.map(
            (r: { name: string; country: { name: string } }) => ({
              key: `region-${r.name}`,
              label: r.name,
              sublabel: enrich(translations.region, r.country.name),
              icon: <Icon variant="gray" icon={faLocationDot} />,
            }),
          )
          updateSuggestions()
        })

      return () => {
        closeP()
        closeR()
      }
    },
    [client, translations],
  )
}
